import { appendParamToUrl } from 'components/utils/string';

export const getImageSources = (imageAssets, retry = false) => {
  let src = '';
  let srcSetItems = [];
  let sources = [];
  if (imageAssets?.length > 0) {
    let webpSrcSetItems = [];
    imageAssets.forEach(a => {
      let s3Uri = a.s3Uri || a.assetUrl // Support old types of assets
      if (retry) {
        s3Uri = appendParamToUrl(s3Uri, 'retry', true);
      }
      if (a.fileExtension !== 'webp') {
        // Add generaly supported formats to srcSet
        if (!a.isDataURL) srcSetItems.push(`${s3Uri} ${a.xResolution}w`);
        // Set src to the first generaly supported format asset
        if (!src) src = s3Uri
      } else {
        if (!a.isDataURL) webpSrcSetItems.push(`${s3Uri} ${a.xResolution}w`);
      }
    });
    if (webpSrcSetItems.length > 0) {
      // Add other formats to sources
      sources.push({ type: `image/webp`, srcSet: webpSrcSetItems.join(', ') });
    }
  }
  return { src, srcSet: srcSetItems.join(', '), sources };
}

export const getVideoSources = (videoAssets) => {
  let videoSources = [];
  if (videoAssets?.length > 0) {
    videoAssets.forEach(c => {
      const s3Uri = c.s3Uri || c.assetUrl // Support old types of assets
      videoSources.push({ type: `video/${c.fileExtension}`, src: s3Uri });
    });
  }
  return videoSources;
}

export const getAspectRatio = (imageAssets) => {
  let aspectRatio = 1.77;
  if (imageAssets?.length > 0) {
    const imageAsset = imageAssets[0];
    aspectRatio = imageAsset.xResolution / imageAsset.yResolution;
  }
  return aspectRatio;
}